import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightArrowLeft, faArrowsRotate, faArrowUpRightFromSquare, faKey, faLayerGroup, faLocationDot, faPhone, faRotateBack, faSquareShareNodes, faStore } from '@fortawesome/free-solid-svg-icons';
import ifoodLogo from '../../../../assets/img/ifood_logo.png';
import anotaAiLogo from '../../../../assets/img/anota_ai_logo.png';
import motumLogo from '../../../../assets/img/motum.svg'
import formatarData from '../utils/formatarDate';
import Conversor from '../../../../helper/Conversor';
import { status_map, status_colors, payment_map } from '../utils/map';
import '../assets/scss/card.scss';
import helmetIcon from '../assets/img/capacete-desenho.png';
import { Tooltip } from '@mui/material';

export default function OrderCard({ order, handleShowModal, handleGroupOrder, showGroupCheck, readyToPickup }) {
    const isIFood = order.orderDetails.isIfood ? true : false;
    const isAnotaAi = order.orderDetails.isAnotaAi ? true : false;

    return (
        <div className="order-card" onClick={() => handleShowModal(order)} style={order.orderDetails.isGrouped ? { width: '100%' } : { borderLeft: '6px solid #000' }}>
            <div className="order-card-header">
                <div className="order-card-key">
                    {(showGroupCheck && !order.orderDetails.isGrouped && (order.orderDetails.status !== 'delivered' && order.orderDetails.status !== 'canceled' && order.orderDetails.status !== 'withdrawn')) && <input type="checkbox" name="group-order" id={`group-order-${order._id}`} style={{ marginRight: 10, cursor: 'pointer', height: 20 }} onClick={(event) => { event.stopPropagation(); handleGroupOrder(order, event); }} />}
                    <FontAwesomeIcon icon={faKey} />
                    <span>#{order.orderDetails.deliveryCode}</span>
                    {order.orderDetails.isGrouped && <FontAwesomeIcon icon={faLayerGroup} title="Agrupamento" style={{ marginLeft: 5, height: 12, color: '#1F456E' }} />}
                </div>
                {order.orderDetails.status === "return" && <div className='return-code'><div className="return-code-title">Código de devolução</div><div className="return-code-text">{order.orderDetails.returnCode}</div></div>}
                <div className="order-card-actions">
                    {(order.orderDetails.orderType && order.orderDetails.type !== "RETURN") && 
                        <Tooltip title={
                            order.orderDetails.orderType === "REVERSE" ? "Entrega Reversa - Entregador busca no destinatário e leva para a loja" : 
                            order.orderDetails.orderType === "SWITCH" ? "Entrega de troca - Entregador vai à loja pegar novo pedido, leva para o destinatário e volta com o pedido trocado para a loja" : 
                            order.orderDetails.payment.type !== "Pago" ? "Entrega com retorno - Entregador faz a entrega e retorna para a loja" : 
                            null
                        } arrow>
                            <div className='order-type'
                            style={
                                order.orderDetails.orderType === "REVERSE" ? { background: '#ffc107'} : 
                                order.orderDetails.orderType === "SWITCH" ? { background: '#fd7e14' } : 
                                order.orderDetails.payment.type !== "Pago" ? { background: '#007bff' } : 
                                null
                            }
                            >
                                <FontAwesomeIcon 
                                    style={{ height: 12 }} 
                                    icon={
                                        order.orderDetails.orderType === "REVERSE" ? faArrowsRotate : 
                                        order.orderDetails.orderType === "SWITCH" ? faArrowRightArrowLeft : 
                                        order.orderDetails.payment.type !== "Pago" ? faRotateBack : 
                                        ''
                                    } 
                                    color='#fff'    
                                />
                                <span>
                                    {
                                        order.orderDetails.orderType === "REVERSE" ? 'Reversa' : 
                                        order.orderDetails.orderType === "SWITCH" ? 'Troca' : 
                                        order.orderDetails.payment.type !== "Pago" ? 'Inclui retorno' : ''
                                    }
                                </span>
                            </div>
                        </Tooltip>    
                    }
                    {(order.deliveryman && order.deliveryman.trackingLink) && <a className='tracking-link' alt="Rastrear pedido" href={order.deliveryman.trackingLink} target="_blank" rel="noreferrer" onClick={(event) => { event.stopPropagation(); }}><FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a>}
                    {order.orderDetails.shared &&
                        <Tooltip style={{ marginRight: 10 }} title="Essa entrega é compartilhada, podendo ser agrupada com pedidos de outras lojas" arrow>
                            <span>
                                <FontAwesomeIcon icon={faSquareShareNodes} style={{ height: 24 }} color="#0d6efd" />
                            </span>
                        </Tooltip>
                    }
                    <div className="order-sales-channel" style={isIFood ? { backgroundColor: "#EA1D2C" } : isAnotaAi ? { backgroundColor: "#0098FC" } : { backgroundColor: "#000" }}>
                        <img src={isIFood ? ifoodLogo : isAnotaAi ? anotaAiLogo : motumLogo} alt="IFood Logo" />
                    </div>
                </div>
            </div>
            <div className="order-card-body">
                <div className="order-store">
                    <div className="order-store-icon">
                        <FontAwesomeIcon icon={faStore} />
                    </div>
                    <div className="order-store-content">
                        <div className="order-store-name">{order.store.companyName}</div>
                    </div>
                </div>
                {(order.deliveryman && order.deliveryman.id) &&
                    <div className="driver-info">
                        <div className="driver-icon">
                            <img src={helmetIcon} alt="Ícone de capacete" />
                        </div>
                        <div className="driver-content">
                            <div className="driver-name">{order.deliveryman.name}</div>
                            <div className="driver-phone"><FontAwesomeIcon icon={faPhone} /> {Conversor.converterFormatoTelefone(String(order.deliveryman.cellNumber))}</div>
                        </div>
                    </div>}
                <div className="delivery-at">
                    <div className="delivery-at-icon">
                        <FontAwesomeIcon icon={faLocationDot} />
                    </div>
                    <div className="delivery-at-content">
                        {(order.orderDetails.status !== "unconfirmed" && order.orderDetails.status !== "canceled") && <div className="delivery-at-customer"> {order.requester.name}</div>}
                        <div className="delivery-at-address">{order.requester.address.street}, nº{order.requester.address.number} - {order.requester.address.neighborhood}, {order.requester.address.city} - {order.requester.address.state}</div>
                    </div>
                </div>
                <div className="order-details">
                    <div className="order-payment">
                        <div className="method">{payment_map[order.orderDetails.payment.type] === "DINHEIRO" ? (
                            <span>
                                {` DINHEIRO ${order.orderDetails.payment.change > 0 ?
                                    '(TROCO PARA ' + Conversor.converterStringReal(order.orderDetails.payment.change) + ')' : ('(Não precisa de troco)')}`}
                            </span>
                        ) : (
                            <span>
                                {` ${order.orderDetails.payment.brand ? order.orderDetails.payment.brand.toUpperCase() + ` ` : ``}`}
                                {payment_map[order.orderDetails.payment.type]}
                            </span>
                        )}</div>
                        <div className="value">{Conversor.converterStringReal(order.orderDetails.payment.price)}</div>
                    </div>
                </div>
            </div>
            <div className="order-card-footer">
                <div className="order-card-status-container">
                    <div className="order-card-status">
                        <div className="status-point" style={{ backgroundColor: status_colors[order.orderDetails.status] }}></div>
                        <span>{status_map[order.orderDetails.status]}</span>
                    </div>
                    <div className="order-card-date">{order.orderDetails.isAvailableForDelivery ? formatarData(order.orderDetails.readyPickUpAt, true) : formatarData(order.orderDetails.createdAt)}</div>
                </div>
                {(
                    (order.orderDetails.status === "pending" || order.orderDetails.status === "accept" || order.orderDetails.status === "arrived")
                    && !order.orderDetails.isAvailableForDelivery && !order.orderDetails.isGrouped
                ) &&
                    <button className="order-card-button" onClick={(event) => { event.stopPropagation(); readyToPickup(order._id, order.orderDetails.deliveryCode); }}>Pedido pronto</button>
                }
            </div>
        </div>
    );
}